import React from "react";
import TableBody from "@material-ui/core/TableBody";

import Rows from "./Rows";

class Body extends React.Component {
  render() {
    return (
      <TableBody>
        <Rows {...this.props} />
      </TableBody>
    );
  }
}

export default Body;
